import React from 'react';
export function Footer() {
  return <footer className="py-5 px-4 sm:px-6 bg-ink text-center text-white/70 text-[11px] sm:text-xs" data-id="element-57" data-mp="32wd2qgad7ltj">
      <p className="font-semibold mb-1.5" data-id="element-58" data-mp="3ggk72reij5xy">
        © 2026 SENIOR FITNESS PRO™ — Tous droits réservés.
      </p>
      <p className="leading-snug max-w-3xl mx-auto mb-2.5" data-id="element-59" data-mp="32lrlbb814tix">
        Les informations présentées dans ce système sont exclusivement destinées
        à des fins pédagogiques et professionnelles. Elles ne remplacent ni votre
        jugement professionnel, ni votre responsabilité en tant que coach ou
        enseignant. Adaptez toujours les exercices, les séances et les
        progressions au niveau, aux capacités et aux objectifs de chacun de vos
        participants.
      </p>
      <div className="flex justify-center items-center gap-2 font-semibold" data-id="element-60" data-mp="3qbvnrf9hen8c">
        <a href="#" className="hover:text-gold transition-colors" data-id="element-61" data-mp="29y5fdwbbxcsw">
          Conditions générales
        </a>
        <span data-id="element-62" data-mp="2ez1k2c3i92zd">•</span>
        <a href="#" className="hover:text-gold transition-colors" data-id="element-63" data-mp="2ew700loelk6h">
          Politique de confidentialité
        </a>
        <span data-id="element-64" data-mp="3lbdb8osqm1jp">•</span>
        <a href="#" className="hover:text-gold transition-colors" data-id="element-65" data-mp="3gaz376r4yrlo">
          Contact
        </a>
      </div>
    </footer>;
}